import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { fetchAllEventPhotos } from "../../../api/publicPhotos";
import { EventPhotoCardGrid } from "../Home/RecentEventPhotos";
import "./eventGallery.css";

// Public "all event photos" page (/photos/events, no login needed).
// Same cards as the homepage's Recent Event Photos section, but for
// EVERY event with approved photos — no homepage cap or exclusions.
// Each card opens that event's full gallery.

const AllEventPhotos = () => {
  const navigate = useNavigate();
  const [events, setEvents] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    fetchAllEventPhotos()
      .then((data) => {
        if (alive) setEvents(Array.isArray(data.events) ? data.events : []);
      })
      .catch((err) => {
        if (alive) setError(err.message || "Couldn't load event photos.");
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="event-gallery">
      <div className="event-gallery__topbar">
        <Link to="/" className="event-gallery__back">
          ← activebeaches.com
        </Link>
        <button
          type="button"
          className="event-gallery__join"
          onClick={() => navigate("/join")}
        >
          JOIN
        </button>
      </div>

      <h1 className="event-gallery__title">📷 Event Photos</h1>
      <div className="event-gallery__meta">
        {events
          ? `${events.length} event${events.length === 1 ? "" : "s"} — tap one to see (and download) all its photos`
          : ""}
      </div>

      {events === null && !error && (
        <p style={{ color: "#6a7385" }}>Loading events…</p>
      )}
      {error && <div className="event-gallery__error">{error}</div>}
      {events && events.length === 0 && (
        <p style={{ color: "#6a7385" }}>No event photos yet.</p>
      )}

      {events && events.length > 0 && (
        <EventPhotoCardGrid events={events} />
      )}
    </div>
  );
};

export default AllEventPhotos;
